import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Car } from 'app/models/car.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CarService {

    cars: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getCars(companyId: number): Promise<Array<Car>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "cars/" + companyId)
                .subscribe((response: any) => {
                    this.cars = response;
                    this.onChanged.next(this.cars);
                    resolve(response);
                }, reject);
        });
    }
    getByCar(plate: string): Promise<Car> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "cars/getbycar?plate=" + plate)
                .subscribe((response: any) => {
                    this.cars = response;
                    this.onChanged.next(this.cars);
                    resolve(response);
                }, reject);
        });
    }

    getByCarImei(imei: string): Promise<Car> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "cars/getbycarimei?imei=" + imei)
                .subscribe((response: any) => {
                    this.cars = response;
                    this.onChanged.next(this.cars);
                    resolve(response);
                }, reject);
        });
    }

    getByPolygon(polygonId: number): Promise<Array<Car>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "cars/getbypolygon?polygonId=" + polygonId)
                .subscribe((response: any) => {
                    this.cars = response;
                    this.onChanged.next(this.cars);
                    resolve(response);
                }, reject);
        });
    }

    add(entity: Car): Promise<Car> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "cars/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(entity: Car): Promise<Car> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "cars/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    delete(entity: Car): Promise<Car> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "cars/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
